<template lang="pug">
.fondoModal
	div 
		div
			.card
				.card-header
					| Auditor de emisión
					button.close(type="button" aria-label="Close" @click="cerrar")
						span(aria-hidden="true")| &times;
				.card-body.text-left
					.row
						.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
							h4.text-info.mb-3 Selecciona el fichero para auditar
								button(:class="(auditando === fichero.ID_fichero) ? 'btn-info' : 'btn-default'" class="btn btn-block btn-sm m-1" v-for="fichero in ficheros" :key="fichero.ID_fichero" style="cursor:pointer;" @click="auditando = fichero.ID_fichero")
										| ({{fichero.xframe_num}}) - {{fichero.nombre}}
						.col-xs-12.col-sm-12.col-md-8.col-lg-8.col-xl-8
							detalles(:idfichero="auditando" :idversion="version.ID_version" v-if="auditando")
</template>

<script>

import DetallesAuditor from '../auditor/detalles'
import API from '../../services/api'

export default {
	name: 'auditor',
	props: ['idtarea'],
	components: {
		'detalles': DetallesAuditor
	},

	data: function () {
		return {
			radiacion: {
				emitidos: [],
				programados: []
			},
			tarea: null,
			auditando: null,
			verTipo: 'programados'
		}
	},

	created () {
		this.getTarea()

		window.addEventListener('keypress', this.teclaPulsada)
	},

	computed: {
		version () {
			return this.tarea.versiones[this.tarea.versiones.length - 1]
		},
		ficheros () {
			if (!this.tarea) {
				return []
			}

			const version = this.tarea.versiones[this.tarea.versiones.length - 1]

			const arr = []

			for (let i = 0; i < version.ficheros.length; i++) {
				if (version.ficheros[i].xframe_ID || version) {
					arr.push(version.ficheros[i])
				}
			}

			return arr
		},

		detalles () {
			if (this.radiacion.programados.length === 0) {
				return []
			}

			const arr = {}

			for (let emisora in this.radiacion.programados) {
				const items = this.radiacion.programados[emisora]
				arr[emisora] = (arr[emisora]) ? arr[emisora] : {items: [], emitidos: 0}

				for (let i = 0; i < items.length; i++) {
					const item = items[i]
					item.emisora = emisora

					const idProg = items[i].ID_programacion

					for (let emi in this.radiacion.emitidos) {
						const emis = this.radiacion.emitidos[emi]

						for (let e = 0; e < emis.length; e++) {
							if (idProg === emis[e].ID_programacion) {
								item.emitido = emis[e]
								arr[emisora].emitidos++
							}
						}
					}

					arr[emisora].items.push(item)
				}
			}

			return arr
		},
		detallesEmitidos () {
			if (this.radiacion.emitidos.length === 0) {
				return []
			}

			const arr = {}

			for (let emisora in this.radiacion.emitidos) {
				arr[emisora] = (!arr[emisora]) ? [] : arr[emisora]
				arr[emisora] = arr[emisora].concat(this.radiacion.emitidos[emisora])
			}

			return arr
		}
	},

	methods: {
		teclaPulsada (e) {
			if (e.keyCode === 27) {
				this.cerrar()
			}
		},
		getTarea () {
			API.getTarea(this.idtarea)
				.then(res => {
					this.tarea = res.data.tarea

					if (this.ficheros.length === 1) {
						this.auditando = this.ficheros[0].ID_fichero
					}
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		cerrar () {
			window.removeEventListener('keypress', this.teclaPulsada)
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/buscador/auditor.vue